import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v3/stock/orderlist-filter';
}

/**
 *
 * @param {string} url
 * @returns
 */
function callbackFetch(url, size) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {import('./typedefs').OrderListFilterResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          page_size: size,
        },
      });

      if (Array.isArray(res?.data?.result?.results)) {
        res.data.result.results = res.data.result.results.map((item) => {
          return { ...item, is_amend: item.is_ammend };
        });
      }

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch({ pageSize = 15 } = {}) {
  const url = getUrl();
  const cb = callbackFetch(url, pageSize);
  const key = [url, pageSize];

  return { cb, key };
}
